// extracted by mini-css-extract-plugin
export default {"images":"CropperPage_images__DmA0G","size":"CropperPage_size__uTZ-H","tools":"CropperPage_tools__uEQxM","canvas_container":"CropperPage_canvas_container__nz+A7"};